// @flow
import { put, call, select } from 'redux-saga/effects';
import { tripica } from '../../../api';
import { deliveryAddressSelector, deliveryGeolocationSelector } from '../DeliveryAddress';
import { setDeliveryMethods } from './actions';
import { setLoading } from '../../LoadingStatus';

import HandleErrorService from '../../../lib/handleError';
import I18n from '../../../lib/i18n';
import WizzeeLog from '../../../lib/wizzeeLog';

export function* checkPremiumEligibilitySaga(): Generator<*, *, *> {
  yield put(setLoading('checkPremiumEligibility', true));

  try {
    const deliveryAddress = yield select(deliveryAddressSelector);
    const geolocation = yield select(deliveryGeolocationSelector);
    const postCode = geolocation ? deliveryAddress.postCode : 'YYYY';
    const result = yield call([tripica, 'getDeliveryPrice'], { Postcode: postCode });
    if (result.ResponseCode === 'SUCCESS') {
      yield put(setDeliveryMethods(result.DeliveryPartnerList, !!geolocation));
    } else {
      throw new Error(result.ResponseMessage);
    }
  } catch (e) {
    HandleErrorService.showToastError(e, () => I18n.t('SignUp.DeliveryMethod.error'));

    WizzeeLog.warn('[saga] checkPremiumEligibiliySaga', e);
  } finally {
    yield put(setLoading('checkPremiumEligibility', false));
  }
}
